function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvvg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    style: {
      maxWidth: "100%"
    },
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.348,223.882h-53.345c-5.891,0-10.656,4.773-10.656,10.665c0,5.891,4.766,10.664,10.656,10.664h53.345   c5.891,0,10.656-4.773,10.656-10.664C512.004,228.656,507.238,223.882,501.348,223.882z",
    style: {},
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.003,202.546c1.406,0,2.734-0.273,3.969-0.766l0,0l0.172-0.062c0-0.008,0.016-0.008,0.031-0.016l53.126-21.25v-0.008   c3.938-1.57,6.703-5.406,6.703-9.898c0-5.891-4.766-10.665-10.656-10.665c-1.406,0-2.734,0.273-3.969,0.766v-0.008l-0.172,0.078   c-0.016,0-0.016,0-0.016,0l-53.142,21.258v0.008c-3.922,1.57-6.703,5.406-6.703,9.898   C437.347,197.772,442.112,202.546,448.003,202.546z",
    style: {},
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.674,178.124V85.208c0-5.891-4.781-10.664-10.672-10.664c-5.875,0-10.656,4.773-10.656,10.664v6.407l-192.003,57.594   H63.997c-5.875,0-10.656,4.782-10.656,10.672v21.329h-32c-5.891,0-10.672,4.781-10.672,10.672v21.328   c-5.891,0-10.672,4.782-10.672,10.672l0,0v21.329l0,0l0,0c0,5.891,4.781,10.672,10.672,10.672v21.336   c0,5.891,4.781,10.656,10.672,10.656h32v21.345c0,5.891,4.781,10.656,10.656,10.656h15.094l27.579,117.58h96.001l-26.61-76.392   c3.156-1.844,5.281-5.25,5.281-9.188c0-3.719-1.906-7-4.812-8.906l10.375-21.423l186.44,55.938v6.391   c0,5.906,4.781,10.672,10.656,10.672c5.891,0,10.672-4.766,10.672-10.672v-94.908c19.126-11.062,32.001-31.734,32.001-55.422   C426.675,209.858,413.8,189.187,394.674,178.124z M31.997,266.547v-64.001h21.344v64.001H31.997z M74.669,170.546h106.673v128.001   H74.669V170.546z M123.592,416.127l-22.578-96.251h62.985l-10.594,21.938l-3.86,7.969l2.907,8.344l20.203,58H123.592z M202.671,304   v-15.047l0.203-0.391h-0.203V165.084l170.674-51.196v241.332L202.671,304z M394.674,261.719v-56.353   c6.642,7.523,10.673,17.383,10.673,28.181C405.347,244.336,401.315,254.203,394.674,261.719z",
    style: {},
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.301,288.656L505.301,288.656l-53.126-21.266c-0.016-0.008-0.031-0.008-0.031-0.016l-0.172-0.062v0.008   c-1.234-0.492-2.562-0.773-3.969-0.773c-5.891,0-10.656,4.773-10.656,10.672c0,4.484,2.781,8.312,6.703,9.906l0,0l53.126,21.251   c0.016,0,0.031,0,0.047,0.016l0.156,0.062v-0.016c1.234,0.5,2.562,0.781,3.969,0.781c5.891,0,10.656-4.782,10.656-10.673   C512.004,294.062,509.238,290.219,505.301,288.656z",
    style: {},
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvvg5);
export default __webpack_public_path__ + "static/media/svvg5.cde69935ed09cf6fa10e0566286c3c24.svg";
export { ForwardRef as ReactComponent };